let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("duRhh")).then(() => parcelRequire('9uyTE'));